import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { Url, URLS } from '@wix/da-url';
import { BiData } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { ThemeOverride, ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import CoreIcon from '@wix/da-ds/pkg/Icons/24x24/Core';
import GiftIcon from '@wix/da-ds/pkg/Icons/24x24/Gift';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { formatDate, DATE_FORMATS } from '@wix/da-ds/pkg/Time/functions';
import { BannerButton, BannerLayout, BannerMessage } from '@wix/da-ds/pkg/Banner/lego';
import s from './SaleBanner.scss';
const SaleBanner = ({ discountValuePercent, endDate, isNarrow, giftRecipient, referralType, className })=>{
    const { t, i18n } = useTranslation();
    const isMobile = useContext(MobileContext);
    const isGift = !!giftRecipient;
    const localeKeys = getLocaleKeys(isGift, isMobile, isNarrow);
    const isShowingPreamble = !isNarrow && !isMobile;
    const href = giftRecipient ? Url.giveCoreMembership(giftRecipient) : URLS.CORE_MEMBERSHIP;
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        className: s['theme-override-wrapper'],
        theme: ThemeOptions.LIGHT
    }, /*#__PURE__*/ React.createElement(BannerLayout, {
        className: c(s['root'], className),
        size: isNarrow ? 'small' : 'big',
        body: [
            isShowingPreamble && /*#__PURE__*/ React.createElement(BannerMessage, {
                key: "message-before-icon",
                weight: "reg"
            }, t(localeKeys.preamble, {
                username: giftRecipient
            })),
            isGift ? /*#__PURE__*/ React.createElement(GiftIcon, {
                key: "gift-icon",
                className: s['gift-icon'],
                size: IconSize.SMALLER,
                role: "presentation"
            }) : /*#__PURE__*/ React.createElement(CoreIcon, {
                key: "core-icon",
                size: IconSize.SMALLER,
                role: "presentation"
            }),
            /*#__PURE__*/ React.createElement(BannerMessage, {
                key: "message-after-icon",
                weight: isNarrow ? 'reg' : 'bld'
            }, t(localeKeys.sale, {
                sale: discountValuePercent,
                date: endDate ? formatDate(endDate, DATE_FORMATS.Date.DayLongMonth, i18n.language) : undefined
            }))
        ],
        postfix: /*#__PURE__*/ React.createElement(BannerButton, {
            variant: isNarrow ? 'underline' : 'ghost',
            href: href,
            biData: BiData({
                evid: 375,
                referral_info: referralType
            })
        }, t(localeKeys.button))
    }), ' ');
};
SaleBanner.displayName = 'SaleBanner';
export default SaleBanner;
function getLocaleKeys(isGift, isMobile, isNarrow) {
    // saleBanner.mobile.preamble
    // saleBanner.mobile.sale
    // saleBanner.mobile.button
    // saleBanner.narrow.preamble
    // saleBanner.narrow.sale
    // saleBanner.narrow.button
    // saleBanner.preamble
    // saleBanner.sale
    // saleBanner.button
    // saleBanner.gift.mobile.preamble
    // saleBanner.gift.mobile.sale
    // saleBanner.gift.mobile.button
    // saleBanner.gift.narrow.button
    // saleBanner.gift.preamble
    // saleBanner.gift.sale
    // saleBanner.gift.button
    let keyBase = 'saleBanner';
    if (isGift) {
        keyBase += '.gift';
    }
    if (isMobile) {
        keyBase += '.mobile';
    } else if (isNarrow) {
        keyBase += '.narrow';
    }
    return {
        preamble: `${keyBase}.preamble`,
        sale: `${keyBase}.sale`,
        button: `${keyBase}.button`
    };
}

//# sourceMappingURL=SaleBanner.js.map